import { render, staticRenderFns } from "./mail-renew-status-list.vue?vue&type=template&id=b822b302&scoped=true&"
import script from "./mail-renew-status-list.vue?vue&type=script&lang=js&"
export * from "./mail-renew-status-list.vue?vue&type=script&lang=js&"
import style0 from "./mail-renew-status-list.vue?vue&type=style&index=0&id=b822b302&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b822b302",
  null
  
)

export default component.exports